import React from 'react';
import PropTypes from 'prop-types';

function Phone({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 15.98v2.408a1.604 1.604 0 01-1.094 1.527 1.613 1.613 0 01-.66.079 15.941 15.941 0 01-6.943-2.465 15.672 15.672 0 01-4.827-4.818 15.868 15.868 0 01-2.47-6.96 1.603 1.603 0 01.953-1.614c.204-.09.425-.137.648-.137h2.414A1.61 1.61 0 019.63 5.381c.102.77.29 1.528.563 2.256a1.602 1.602 0 01-.362 1.694l-1.022 1.02a12.86 12.86 0 004.827 4.817l1.022-1.02a1.61 1.61 0 011.697-.36c.73.271 1.488.46 2.26.561A1.61 1.61 0 0120 15.98z"
      />
    </svg>
  );
}

Phone.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Phone;
